import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { Product } from "../../../domain/entities/product/Product";
import { financial } from "../shared/util/financial/financial";
import { Constants, PROJECT, ShowNotifyStockButtonTrackingEvent, TrackingEventName } from "./tracking";

interface TrackShowNotifyStockButtonFunctionArgs {
  readonly product: Product;
}

interface TrackShowNotifyStockButtonFunction {
  (args: TrackShowNotifyStockButtonFunctionArgs): void;
}

interface UseTrackShowNotifyStockButtonFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackShowNotifyStockButtonFunction {
  (agrs: UseTrackShowNotifyStockButtonFunctionArgs): TrackShowNotifyStockButtonFunction;
}

const useTrackShowNotifyStockButton: UseTrackShowNotifyStockButtonFunction = ({
  country,
  segment,
  tradename,
  userId,
}) => {
  const emitUserEvent = useEmitUserEvent<ShowNotifyStockButtonTrackingEvent>();

  const trackShowNotifyStockButton: TrackShowNotifyStockButtonFunction = useCallback(
    ({ product }) => {
      emitUserEvent({
        event: TrackingEventName.SHOW_NOTIFY_STOCK_BUTTON,
        eventCategory: TrackingEventCategory.LOOK_IN,
        store: country,
        section: PROJECT,
        segment,
        tradename,
        userId,
        userUuid: userId,
        variant_id: product.variantId,
        items: [
          {
            item_name: product.title,
            item_id: product.variantId,
            item_price: financial(product.price.amount),
            item_brand: product.brand,
            item_category: Constants.NOT_SET,
            item_variant: product.size,
            item_list: Constants.COMPLETE_YOUR_LOOK_LIST,
            item_index: Constants.INDEX,
            item_look_id: Constants.NOT_SET,
            item_quantity: Constants.QUANTITY,
          },
        ],
      });
    },
    [country, emitUserEvent, segment, tradename, userId],
  );

  return trackShowNotifyStockButton;
};

export { useTrackShowNotifyStockButton };
